import { useQuery } from '@tanstack/react-query';
import type { Entity } from '@backstage/catalog-model';
import { useApi } from '@backstage/core-plugin-api';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import { hasDocsSite } from '../utils/docCategory';

export const DOC_ENTITIES_QUERY_KEY = 'docEntities' as const;

const DOC_ENTITY_FIELDS = [
  'kind',
  'metadata.namespace',
  'metadata.name',
  'metadata.title',
  'metadata.annotations',
];

/** Preserves entityRefs order so that recent docs stay in read-history order. */
export function useDocEntities(entityRefs: string[]) {
  const catalogApi = useApi(catalogApiRef);

  return useQuery({
    queryKey: [DOC_ENTITIES_QUERY_KEY, entityRefs],
    queryFn: async (): Promise<Entity[]> => {
      if (entityRefs.length === 0) {
        return [];
      }
      const { items } = await catalogApi.getEntitiesByRefs({
        entityRefs,
        fields: DOC_ENTITY_FIELDS,
      });
      return items.filter(
        (entity): entity is Entity => !!entity && hasDocsSite(entity),
      );
    },
  });
}
